<template>
  <v-card
    v-if="haveSchema"
    outlined
    elevation="0"
  >
    <tree
      v-model="cloneRequestSchema"
      :name="name"
      :schema="schema"
    />
  </v-card>
</template>

<script>
import Tree from './SchedulerRequestField/Tree'
import { cloneDeep } from 'lodash'

export default {
  components: {
    Tree
  },

  props: [
    'name',
    'schemaKey',
    'schema',
    'value'
  ],

  data() {
    return {
      cloneRequestSchema: undefined
    }
  },

  computed: {
    haveSchema() {
      return (
        this.schema !== undefined && this.schema !== null && this.schema !== '' && Object.keys(this.schema).length > 0
      )
    }
  },

  watch: {
    cloneRequestSchema() {
      this.$emit('input', this.cloneRequestSchema)
    }
  },
  created() {
    this.cloneRequestSchema = cloneDeep(this.value)
    if (this.cloneRequestSchema === '' || this.cloneRequestSchema === undefined) this.cloneRequestSchema = {}
  }
}
</script>

<style></style>
